import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import colors from '../../themes/main-colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      '& .MuiTextField-root': {
        margin: theme.spacing(1, 0),
        flexDirection: 'row',
        display: 'flex',
      },
      '& .MuiFormControl-root': {
        display: 'flex',
        flexDirection: 'column',
      },
      '& .MuiGrid-justify-xs-center': {
        justifyContent: 'flex-start',
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: 0,
      },
      '& .MuiInputLabel-asterisk': {
        color: colors.errorRed,
      },
    },
    container: {
      background: colors.riverBlue,
      padding: theme.spacing(4),
      marginTop: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1),
      },
    },
    textPrimary: {
      color: colors.noirBlur,
    },
    colorTextPrimary: {
      color: colors.noirBlur,
    },
    paper: {
      marginTop: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      zIndex: -1,
    },
    card: {
      // minWidth: 275,
      justifyContent: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(4),
      width: '100%',
      color: colors.noirBlur,
      boxShadow: 'none',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
    },
    spacing: {
      padding: '1em',
    },
    radioSubtitle: {
      marginLeft: 22,
    },
    or: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
      marginTop: '2em',
      fontWeight: 'normal',
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: '0.5em',
        marginBottom: '0.5em',
        width: '100%',
        textAlign: 'center',
      },
    },
    and: {
      paddingBottom: '1em',
      width: '50%',
      textAlign: 'center',
      fontWeight: 'normal',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginTop: '1.5em',
        marginBottom: '1.5em',
      },
    },
    backButton: {
      [theme.breakpoints.up('md')]: {
        marginTop: '1em',
      },
      [theme.breakpoints.down('md')]: {
        width: '100%',
        marginTop: '0em',
      },
    },
    buttonWrapper: {
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    buttonContainer: {
      width: '100%',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
      },
    },
    overflowField: {
      '& label': {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        right: 0,
        paddingRight: 24,
        overflow: 'hidden',
      },
    },
    greenCheck: {
      color: colors.shoreGreen,
      fontSize: '4rem',
      paddingBottom: 10,
      [theme.breakpoints.down('sm')]: {
        fontSize: '3rem',
      },
    },
    dropdownMinWidthAuto: {
      '& .MuiFormControl-root': {
        minWidth: 'auto',
      },
    },
    noRightBorder: {
      '& fieldset': {
        borderRight: 'none',
      },
    },
    accountTypeDropdown: {
      [theme.breakpoints.down('sm')]: {
        maxWidth: '120px',
      },
    },
    labelAsterisk: {
      color: 'red',
    },
    applyingForBox: {
      border: `1px solid ${colors.lightGray}`,
      backgroundColor: colors.white,
      borderRadius: '16px',
      padding: '48px 0',
      width: '333px',
      textAlign: 'center',
      fontSize: '18px',
      cursor: 'pointer',
      fontFamily: 'Untitled-Sans',
      transition: 'all 0.2s',
    },
    selectedApplyingForBox: {
      background: colors.riverBlue,
      boxShadow: '0px 3px 6px #0000004D',
      fontWeight: 500,
    },
    miniApplyingForBox: {
      padding: '12px',
    },
  }),
);

export default useStyles;
